// extracted by mini-css-extract-plugin
export var button = "index-module--button--f4de9";
export var checked = "index-module--checked--f1823";
export var copied = "index-module--copied--e8120";
export var copiedText = "index-module--copiedText--3d49d";
export var copyIcon = "index-module--copyIcon--c4aa2";
export var icon = "index-module--icon--0a9a1";